import TH_Translate from '_tradeholding/js/Classes/Translate';

const Translate = new TH_Translate();

export default Translate;